var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.snackbars, function(snackbar) {
      return _c(
        "div",
        [
          _c(
            "v-snackbar",
            {
              attrs: {
                bottom: snackbar.position.includes("bottom"),
                color: snackbar.color,
                left: snackbar.position.includes("left"),
                right: snackbar.position.includes("right"),
                timeout: snackbar.timeout,
                top: snackbar.position.includes("top"),
                vertical: true,
                "multi-line": ""
              },
              model: {
                value: snackbar.show,
                callback: function($$v) {
                  _vm.$set(snackbar, "show", $$v)
                },
                expression: "snackbar.show"
              }
            },
            [
              _vm._v(" " + _vm._s(snackbar.text) + " "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", text: "" },
                  on: {
                    click: function($event) {
                      snackbar.show = false
                    }
                  }
                },
                [_vm._v(" OK ")]
              )
            ],
            1
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }